import {
  useMutation,
  type MutationHookOptions,
  type MutationTuple,
  type TypedDocumentNode,
} from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateShowTagsDocument } from './update.generated';

const useUpdate = <T, U>(
  document: TypedDocumentNode<T, U>,
  options: MutationHookOptions<T, U>,
): MutationTuple<T, U> => {
  const { t } = useTranslation();

  return useMutation(document, {
    ...useNotifications(document, {
      failure: t('api.show_tags.update_error'),
      success: t('api.show_tags.update_success'),
    }),
    ...options,
  });
};

export const useUpdateShowTags = (options: ApiOptions<typeof UpdateShowTagsDocument> = {}) =>
  useUpdate(UpdateShowTagsDocument, options);
